import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { LayoutComponent } from 'src/app/layout/layout.component';
@Component({
  selector: 'app-wmsm-OnlineFile',
  templateUrl: './wmsm-OnlineFile.component.html',
  styleUrls: ['./wmsm-OnlineFile.component.scss']
})
export class WmsmOnlineFileComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  validateForm: FormGroup;
  UploadvalidateForm: FormGroup;
  RenamevalidateForm: FormGroup;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  // 前档点击行的数据
  rowData: any;
  fileList: NzUploadFile[] = [];
  ShowUploadPage: boolean = false;
  UploadOK: boolean = false;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  UploadToken: string;
  //操作时取当前文件数据
  ActData: any;
  updateFlag: boolean;
  ShowRenamePage: boolean;
  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private translate: TranslateService,
    private http: HttpClient,
    private LayoutComponent: LayoutComponent,
    private modalService: NzModalService,


  ) { super() }

  ngOnInit() {
    this.validateForm = this.fb.group({
      StoreField: [''],
    });
    this.UploadvalidateForm = this.fb.group({
      FileTarget: ['', [Validators.required]]
    });
    this.RenamevalidateForm = this.fb.group({
      Name: ['', [Validators.required]]
    });
    this.LayoutComponent.geturl()
    this.matomotracker.trackPageView("系統管理員權限設置")
    this.matomotracker.trackEvent("系統管理員權限設置", "線上文件存放", "Transation", 1);
  }
  // 查询
  submitForm = ($event: any, value: any) => {
    $event.preventDefault();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
  };
  onSearch() {
    if (this.validateForm.controls['StoreField'].value == null ||
      this.validateForm.controls['StoreField'].value == undefined ||
      this.validateForm.controls['StoreField'].value == '') {
      this.NzMessageService.warning(this.translate.instant("PleaseSelectFilePurpose"));
      return;
    } else {
      this.pageIndex = 1;
      this.getResultData(this.validateForm.controls['StoreField'].value);
    }
  }
  // 获取查询表格数据
  getResultData(filePurpose: string) {
    this.loading = true;
    const params = 'filePurpose=' + filePurpose;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetFileToken.url}`;
    this.WebApiService.doGet(url, params).subscribe(
      (res) => {
        if (
          res &&
          res.status == this.EnvironmentconfigService.authConfig.wmsmStatus
        ) {
          this.listOfData = res.data;
          this.nzTotal = res.total;
          this.NzMessageService.success(res.msg);
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.NzMessageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
  }
  // 切换每页数据条数
  // nzPageSizeChange(event: number): void {
  //   if (this.nzTotal === 0) {
  //     return;
  //   }
  //   this.pageSize = event;
  //   if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
  //     this.pageIndex--;
  //   }
  //   this.getResultData();
  // }
  // 切换页码
  // nzPageIndexChange(event: number): void {
  //   this.pageIndex = event;
  //   this.getResultData();
  // }
  // 显示增加/修改/删除action
  showAction(event, data) {
    data.isShowAction = true;
    this.rowData = data;
  }
  DownloadByToken(Token: string, FileName: string): void {
    this.loading = true;
    this.WebApiService.downloadFileByToken(Token).subscribe(
      (res) => {
        this.downloadFile8(res, FileName);
        this.NzMessageService.success(res.msg);
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
  }
  beforeUpload = (file: NzUploadFile): boolean => {
    this.saveExcelData(file, false);
    this.ShowUploadPage = false;
    return false;
  };

  saveExcelData(file, isUpdate: boolean) {
    this.loading = true;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', isUpdate ? this.ActData.filePurpose : this.UploadvalidateForm.controls['FileTarget'].value);
    formData.append('category', "OnlineDocument");
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.Upload.url}`;
    const _headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + this.AuthService.getToken()
    ).set('IdentityType', this.AuthService.getCurrentUserInfo()?.userType || '');
    const req = new HttpRequest('POST', url, formData, {
      headers: _headers,
    });
    this.http
      .request(req)
      .pipe(filter((e) => e instanceof HttpResponse))
      .subscribe(
        (res) => {
          if (res['body'].status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
            this.getResultData(isUpdate ? this.ActData.filePurpose : this.UploadvalidateForm.controls['FileTarget'].value);
            this.NzMessageService.success(res['body'].msg);
          } else {
            this.NzMessageService.warning(res['body'].msg);
          }
          this.loading = false;
        },
        (error) => {
          this.NzMessageService.error('upload failed.');
          this.loading = false;
        }
      );
  }
  handleCancel() {
    this.ShowUploadPage = false;
    this.ShowRenamePage = false;
  }
  UploadPage() {
    this.ShowUploadPage = true;
  }
  onDowmload(data) {
    this.DownloadByToken(data.fileToken, data.fileName);
  }

  // 删除
  onDelete(data, updateFlag) {
    //更新之前需要先删除
    if (updateFlag) {
      this.loading = true;
      const params = {
        data: {
          FileName: data.fileName,
          FileToken: data.fileToken
        }
      }
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.DeleteFile.url}`;
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {
          if (
            res &&
            res.status == this.EnvironmentconfigService.authConfig.wmsmStatus
          ) {
            //消息提示放在更新
          }
          this.loading = false;
        },
        (error) => {
          this.NzMessageService.error(error.msg);
          this.loading = false;
        }
      );
    }
    //删除
    else {
      this.modalService.confirm({
        nzTitle: "Do you Want to delete these items?",
        nzContent: this.translate.instant("IsConfirmDeletion"),
        nzOnOk: () => {
          const params = {
            data: {
              FileName: data.fileName,
              FileToken: data.fileToken
            },
          };
          const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.DeleteFile.url}`;
          this.WebApiService.doPost(url, params).subscribe(
            (res) => {
              if (
                res &&
                res.status == this.EnvironmentconfigService.authConfig.wmsmStatus
              ) {
                this.getResultData(data.filePurpose);
                this.NzMessageService.success(res.msg);
              } else {
                this.NzMessageService.warning(res.msg);
              }
              this.loading = false;
            },
            (error) => {
              this.NzMessageService.error(error.msg);
              this.loading = false;
            }
          );
        },
      });
    }

  }
  //更新
  onUpdate(data, updateFlag) {
    this.ActData = data;
    this.updateFlag = updateFlag;
  }

  beforeUpdate = (file: NzUploadFile): boolean => {
    this.onDelete(this.ActData, this.updateFlag)
    this.saveExcelData(file, true);
    return false;
  };
  onRename(data) {
    this.ShowRenamePage = true;
    this.ActData = data;
    this.RenamevalidateForm.controls['Name'].setValue(data.fileName);
  }
  RenameOK() {
    this.loading = true;
    const params = {
      data: {
        FileName: this.RenamevalidateForm.controls['Name'].value,
        FileToken: this.ActData.fileToken
      }
    }
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.UpdateFileName.url}`;
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (
          res &&
          res.status == this.EnvironmentconfigService.authConfig.wmsmStatus
        ) {
          this.NzMessageService.success(res.msg);
          this.ShowRenamePage = false;
          this.getResultData(this.ActData.filePurpose);
        } else {
          this.NzMessageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }
    );
  }
}
